import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import products from '../../../data/products.json';

class Products extends Component {
    render() {
        return (
            <section className="section-padding corona-symptoms parallax">
                <div className="overlay overlay-bg-theme" />
                <div className="container">
                    <div className="section-header">
                        <div className="section-heading text-center">
                            <h3 className="text-custom-white fw-600">Our Products</h3>
                            <div className="section-description">
                                <p className="text-custom-white fs-16 fw-500">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {/* Data */}
                        {products.map((item, i) => (
                            <div className="col-lg-4 col-md-6" key={i}>
                                <div className="corona-sy-grid mb-xl-30">
                                    <div className="img-wrap">
                                        <img src={process.env.PUBLIC_URL + "/" + item.image} className="image-fit rounded-0" alt={item.title} />
                                    </div>
                                    <div className="caption">
                                        <h4 className="no-margin fw-600"><Link to="#" className="text-custom-black">{item.title}</Link></h4>
                                    </div>
                                    <div className="hover-wrap">
                                        <div className="text-wrap">
                                            <h4 className="fw-600"><Link to="#" className="text-custom-black">{item.title}</Link></h4>
                                            <p className="text-light-white mb-xl-20">{item.text}</p>
                                            <Link to="#" className="btn-submit btn_text_effect"><span className="button_title">Read More</span></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* Data */}
                    </div>
                </div>
            </section>
        );
    }
}

export default Products;